export const apiRoutes = {
    userLogin:'/User/UsersLogin',
    getAgentInfoPage:"/UserAgent/GetAgentInfoPage",//代理列表
    getUsersInfoPage:"/UserAccount/AdminAccountPage",//会员列表
    userLogin:"/AdminUsers/AdminUsersLogin",//用戶登录
    commissionLIst:"/UserAgent/GetCommissionStatement",//佣金报表
    addNewPermission:"/Permission/InsertPermission",//新增权限
    getAllPermission:"/Permission/GetPermissionAll",//查询所有权限
    updatePermission:"/Permission/UpdatePermission",//编辑权限
    getAllAdminAccount:"/AdminUsers/GetAdminUsersPage",//后台用户列表
    updateAdminUsers:"/AdminUsers/UpdateAdminUsers",//编辑后台用户
    addAdminUser:"/AdminUsers/InsertAdminUsers",//新增后台用户
    queryUserPermission:"/AdminUsers/GetAdminInfo",//查询后台用户的权限
    updateAdminUserStatus:"/AdminUsers/UpdateAdminAccountStatus",//更新单个user 状态
    userDetailData:"/UserAgent/GetDataOverview",//数据概览
    addNewAgent:"/UserAgent/UserInsert",//新增代理
    getAgentList:"/UserAgent/GetNormalAgents",//代理商列表
    getAgentDataInfo:"/UserAgent/GetAgentById",//单个代理商信息
    editAgentDataInfo:"/UserAgent/UpdateAgentById",//编辑单个代理商信息
    changuserAgent:"/UserAccount/UpdateUsersAgent",//更换用户代理
}